// Whether a sitting's Writing Task cell can offer feedback, and which attempt
// it should open.
//
// The workspace gets its attempt from paper statuses, and that query orders
// in-progress sittings ahead of completed ones. It is the right order for
// resuming an exam and the wrong one for finding work: after starting a paper
// again, the open sitting has no essay, the cell falls back to an inert dash,
// and feedback the student already generated becomes unreachable.
//
// So availability is asked about the paper, and answered by the server, which
// is the only thing that knows where the essay actually is. The sitting's own
// score is the fallback for the ordinary case where they match, so the cell
// still works before the availability call has returned.

export function taraWritingFeedbackAccess({
  writingPaperId,
  dbPapers = {},
  availability = {},
  scoredWriting = null,
} = {}) {
  const none = { available: false, attemptId: null, fromEarlierSitting: false };
  if (!writingPaperId) return none;

  const openAttemptId = dbPapers[writingPaperId]?.attempt_id || null;
  const forPaper = availability[writingPaperId];

  if (forPaper?.attempt_id) {
    return {
      available: true,
      attemptId: forPaper.attempt_id,
      // Only worth saying when it is actually a different sitting. Saying it
      // whenever the server answered would label every ordinary view.
      fromEarlierSitting: Boolean(openAttemptId) && forPaper.attempt_id !== openAttemptId,
      stagesReady: forPaper.stages_ready ?? 0,
    };
  }

  if (scoredWriting && openAttemptId) {
    return { available: true, attemptId: openAttemptId, fromEarlierSitting: false };
  }

  return none;
}
